// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Templates tab — list screen (card grid). Class names prefixed br-tpl- per house convention. */

.br-tpl {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px 0;
}

/* Page header: title + description on the left, channel select + create action on the right. */
.br-tpl-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.br-tpl-header-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.br-tpl-header-title {
  margin: 0;
  color: var(--br-text);
  font-weight: 600;
}

.br-tpl-header-subtitle {
  margin: 0;
  color: var(--br-muted);
}

.br-tpl-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

/* Icon-only Refresh button (List.js). The library sets its size styles (minWidth, padding) under
   sx's "&.MuiButton-root" — two classes, (0,2,0) specificity — so this override needs two classes
   too; it wins at equal specificity because ThemeProvider injects MUI's styles first (injectFirst).
   Same pattern as .br-tpl-form-body-toolbar .MuiButton-text elsewhere in this file.
   customStartIcon renders as a plain <img>, not through MUI's startIcon slot, so there's no
   .MuiButton-startIcon margin to zero out. */
.br-tpl-header-actions .br-tpl-refresh-button {
  min-width: 36px;
  padding-left: 0;
  padding-right: 0;
}

/* Channel select, its own row between the header and the rail/grid layout. Flex-wrapped
   (not block) so the Select sizes to its own small footprint instead of stretching full
   width; vertical spacing above/below comes from .br-tpl's own flex \`gap\`, same as every
   other direct child of .br-tpl — no extra margin needed here. */
.br-tpl-channel-row {
  display: flex;
  align-items: center;
}

/* Two-column body below the header: a plain status rail on the left, search + grid +
   pagination on the right — this pairing runs for the rest of the page. */
.br-tpl-layout {
  display: flex;
  align-items: flex-start;
  gap: 32px;
}

.br-tpl-rail {
  flex: 0 0 180px;
  display: flex;
  flex-direction: column;
  /* No offset: .br-tpl-rail and .br-tpl-main are flex-start siblings in .br-tpl-layout, and the
     search TextField below carries no label of its own, so its outlined box already sits flush
     with the layout's top edge — the Status heading needs the same flush start to line up
     with it. */
  padding-top: 0;
}

/* Section label above the status buttons — quiet, doesn't compete with the items. Left padding
   matches an item's own text start (2px border-left + 12px padding-left = 14px) so "Status"
   and "All" share one vertical edge. */
.br-tpl-rail-heading {
  margin: 0 0 6px;
  padding-left: 14px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--br-faint);
}

.br-tpl-rail-item {
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  border-left: 2px solid transparent;
  padding: 7px 12px;
  font-family: inherit;
  font-size: 13px;
  color: var(--br-muted);
  cursor: pointer;
  border-radius: 0 var(--br-radius) var(--br-radius) 0;
  appearance: none;
}

.br-tpl-rail-item:hover {
  color: var(--br-text);
  background: var(--br-hover);
}

/* Native buttons keep a UA focus ring even after the reset above, and a click focuses the
   button too — so the just-clicked rail item (the one now shown active) picked up an extra
   ring the others never show, reading as misaligned. Drop the plain :focus ring and draw an
   explicit :focus-visible one instead, inset so it never adds width. */
.br-tpl-rail-item:focus {
  outline: none;
}

.br-tpl-rail-item:focus-visible {
  outline: 2px solid var(--br-accent);
  outline-offset: -2px;
}

.br-tpl-rail-item--active {
  color: var(--br-accent);
  font-weight: 600;
  border-left-color: var(--br-accent);
  background: var(--br-hover-strong);
}

.br-tpl-main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.br-tpl-search-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.br-tpl-search-input {
  width: 360px;
  max-width: 100%;
}

.br-tpl-empty {
  margin: 0;
  padding: 40px 0;
  text-align: center;
  font-size: 13px;
  font-weight: 300;
  color: var(--br-muted);
}

/* Card grid — 3 per row, wrapping to fewer on narrower widths. Shared by the real grid and
   the loading skeleton below so both lay out identically. */
.br-tpl-card-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

@media (max-width: 1100px) {
  .br-tpl-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 700px) {
  .br-tpl-card-grid {
    grid-template-columns: 1fr;
  }
}

.br-tpl-card {
  display: flex;
  flex-direction: column;
  min-height: 420px;
  min-width: 0;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-card-radius);
  background: var(--palette-common-white, #fff);
  overflow: hidden;
}

.br-tpl-card-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 12px 0;
}

.br-tpl-card-title {
  color: var(--br-text);
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.br-tpl-card-preview {
  flex: 1 1 auto;
  min-height: 280px;
  padding: 6px 12px;
  overflow: hidden;
}

/* Slightly tinted vs. the card's white body — echoes the console's own darker "Last Updated"
   bar under its preview. */
.br-tpl-card-footer {
  padding: 6px 12px;
  background: var(--br-head-bg);
  border-top: 1px solid var(--br-rule);
}

.br-tpl-card-updated {
  margin: 0;
  font-size: 11px;
  font-style: italic;
  color: var(--br-muted);
}

.br-tpl-card-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border-top: 1px solid var(--br-rule);
}

/* Loading state — the design system has no Skeleton component, so this mirrors the shimmer
   look overrides.css already uses for br-skeleton__row, reshaped into card-shaped
   placeholders (List.js renders PAGE_SIZE of these inside .br-tpl-card-grid above) instead
   of the old row-shaped ones. */
.br-tpl-card-skeleton {
  padding: 12px;
  gap: 10px;
}

.br-tpl-skeleton-bar,
.br-tpl-skeleton-block {
  background: linear-gradient(90deg, #f5f5f8 25%, #eceef2 37%, #f5f5f8 63%);
  background-size: 400% 100%;
  animation: br-tpl-skeleton-pulse 1.4s ease infinite;
}

.br-tpl-skeleton-bar {
  border-radius: 4px;
}

.br-tpl-skeleton-block {
  flex: 1 1 auto;
  min-height: 200px;
  border-radius: 8px;
}

@keyframes br-tpl-skeleton-pulse {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* Pagination's own component renders its page-pills and "Results: X-Y of Z" text as two
   children of a wrapper it styles \`justify-content: space-between\` — but that same wrapper
   is \`margin: 1rem auto\` with no explicit width, so as a direct flex item of .br-tpl-main's
   column layout it never stretches (auto cross-axis margins opt a flex item out of
   align-items: stretch), shrinks to fit-content, and the space-between gap collapses to
   zero. This plain block wrapper takes it out of the flex-item position so Pagination lays
   out in normal block flow instead, where auto width does fill the container. */
.br-tpl-pagination-row {
  width: 100%;
}

/* Read-only detail modal (DetailModal.js). Two columns: facts + message parts on the left, the
   live preview on the right. */
.br-tpl-detail {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.br-tpl-detail-facts {
  flex: 1 1 340px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Fixed-ish width so the WhatsApp-shaped preview keeps its own aspect ratio — never squeezed
   below ~300px even as the facts column beside it gets narrower. */
.br-tpl-detail-preview {
  flex: 0 0 320px;
  min-width: 300px;
}

.br-tpl-detail-list {
  display: grid;
  grid-template-columns: 120px 1fr;
  row-gap: 10px;
  column-gap: 12px;
  margin: 0;
}

.br-tpl-detail-list dt {
  margin: 0;
  color: var(--br-muted);
  font-size: 13px;
  font-weight: 500;
}

.br-tpl-detail-list dd {
  margin: 0;
  color: var(--br-text);
  font-size: 13px;
  word-break: break-word;
}

.br-tpl-detail-list--parts {
  padding-top: 16px;
  border-top: 1px solid var(--br-rule);
}

.br-tpl-detail-list--parts dd {
  white-space: pre-wrap;
}

/* Create/edit form shell (Form/index.js). */
.br-tpl-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px 0;
}

.br-tpl-form-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.br-tpl-form-panes {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.br-tpl-form-pane-form {
  flex: 1 1 67%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.br-tpl-form-pane-preview {
  flex: 0 1 33%;
  min-width: 300px;
  position: sticky;
  top: 24px;
}

.br-tpl-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* One card per section (Form/sections/*.js). The 25px gap between cards comes from
   .br-tpl-form-pane-form's own gap above, not a per-card margin. */
.br-tpl-form-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-card-radius);
}

.br-tpl-form-card-heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.br-tpl-form-card-heading {
  display: flex;
  align-items: center;
  gap: 8px;
}

.br-tpl-form-optional-pill {
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--br-rule);
  color: var(--br-muted);
}

.br-tpl-form-helper-text {
  margin: 0;
  color: var(--br-muted);
}

.br-tpl-form-char-count {
  align-self: flex-end;
  color: var(--br-muted);
}

/* Category section's radio card grid (sections/Category.js). Three equal-width cards; grid's
   own align-items: stretch default plus height: 100% on the card makes every card as tall as
   the tallest description instead of shrink-to-fit around its own text. */
.br-tpl-form-category-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.br-tpl-form-category-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  margin: 0;
  padding: 12px;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-card-radius);
  cursor: pointer;
}

.br-tpl-form-category-card--selected {
  border-color: var(--br-accent);
}

/* Radio, title, then the icon pushed to the card's right edge. Category.js renders the category
   icon through Icon's customPath (a hosted SVG), which gupshup-ts-components renders as a plain
   <img> — img:last-child is the real target, not svg. */
.br-tpl-form-category-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
}
.br-tpl-form-category-card-head img:last-child {
  margin-left: auto;
}

.br-tpl-form-category-radio-input {
  flex: none;
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--br-accent);
  cursor: pointer;
}

.br-tpl-form-subcategory {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Template Type dropdown item (sections/Category.js's SubcategoryOptionLabel) — title row (+ an
   info tooltip icon for Carousel), then the description underneath. */
.br-tpl-form-subcategory-option {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Message validity Select sits beside the Authentication-only info tooltip (sections/
   MessageValidity.js), inside a .br-tpl-form-inline-row. flex:1 lets it fill the row; min-width:0
   stops its own width:100% from pushing the tooltip icon out. */
.br-tpl-form-validity-select {
  flex: 1 1;
  min-width: 0;
}

/* Body toolbar sits under the text area: actions left, character count pushed right. */
.br-tpl-form-body-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
}
/* The shared rule's align-self: flex-end suits the column-flex card, but bottom-aligns this text in the row-flex toolbar — recenter it. */
.br-tpl-form-body-toolbar .br-tpl-form-char-count {
  margin-left: auto;
  align-self: center;
}

/* MUI Button reserves min-width:64px, which scatters these single-glyph controls across the row. */
.br-tpl-form-body-toolbar .MuiButton-root {
  flex: none;
  white-space: nowrap;
}
.br-tpl-form-body-toolbar .MuiButton-text {
  min-width: 0;
  padding: 4px 8px;
}

/* Wraps just the emoji toggle button; inline-flex keeps it sized to the button, not stretched by
   the row. EmojiPickerButton.js measures this element's getBoundingClientRect() to position the
   portaled popover below — the popover is no longer a CSS-anchored child of this wrapper, so
   \`position: relative\` here is vestigial (harmless, kept so this wrapper's own box is unaffected)
   rather than load-bearing. */
.br-tpl-form-emoji-picker-anchor {
  position: relative;
  display: inline-flex;
}

/* Rendered through a React portal onto document.body (EmojiPickerButton.js), not as a DOM child
   of .br-tpl-form-emoji-picker-anchor above — so no ancestor's overflow (a carousel card, the
   sticky preview pane, index.css's tabsPanel) can clip it regardless of scroll position, which is
   what broke on a low-on-the-page trigger with the page already at max scroll. top/left are set
   inline per-open from the trigger's own rect (EmojiPickerButton.js's computePopoverPosition), so
   only \`position\` and \`z-index\` are fixed here. z-index clears every z-index already in this app:
   this stylesheet's own card/sticky-header values (1-5, index.css 3-4) and gupshup-ts-components'
   Modal, which is MUI's Modal under the hood and defaults to zIndex.modal = 1300. */
.br-tpl-form-emoji-picker-popover {
  position: fixed;
  z-index: 1400;
}

/* Variables section rows (sections/Variables.js). */
.br-tpl-form-variable-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* One sample-value row — wraps the row's TextField; the token adornment itself renders inside
   the input via startAdornment, not as a sibling here. */
.br-tpl-form-variable-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.br-tpl-form-variable-token {
  color: var(--br-muted);
  margin-right: 4px;
}

/* Header/media inline states (sections/Header.js). */
.br-tpl-form-header-text,
.br-tpl-form-header-media {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Header text's own action row: Add-variable button left, character count pushed right — same
   idea as .br-tpl-form-body-toolbar below, scoped to the header text field alone. */
.br-tpl-form-header-text-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.br-tpl-form-media-picked {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-radius);
}

/* Inline preview of a picked sample media file (img/video/iframe), shown above
   .br-tpl-form-media-picked once a file is selected. Capped height with object-fit so a large
   image, video or PDF can't blow out the form's layout. */
.br-tpl-form-media-preview {
  display: block;
  width: 100%;
  max-height: 180px;
  object-fit: contain;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-radius);
}

/* Buttons section (sections/Buttons.js). */
.br-tpl-form-buttons-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* One button entry — title/remove strip stacked above its type-specific fields; nested one
   level inside .br-tpl-form-card, hence the smaller padding than a top-level card. */
.br-tpl-form-buttons-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-card-radius);
}

.br-tpl-form-buttons-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Drop-target affordance while dragging a button row over another one via its drag handle. */
.br-tpl-form-buttons-row--drag-over {
  border-color: var(--br-accent);
  background: var(--br-hover);
}

/* Shared by the dynamic-suffix row (the {{1}} token sits inline to the left of the sample-suffix
   input, so the variable WhatsApp appends is visible rather than only described) and the
   deep-link/fallback-URL rows (field plus its trailing info tooltip). */
.br-tpl-form-url-suffix-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.br-tpl-form-url-suffix-token {
  flex: none;
  font-size: 12px;
  color: var(--br-muted);
  white-space: nowrap;
}

/* Checkbox plus its info icon on one line. */
.br-tpl-form-inline-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* App setup rows (sections/AuthAppSetup.js) — package name + signature hash inputs share the
   row, the remove icon keeps its own natural size. */
.br-tpl-form-app-setup-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.br-tpl-form-app-setup-row > *:not(:last-child) {
  flex: 1 1;
  min-width: 0;
}

/* Carousel section (sections/Carousel.js). */
.br-tpl-form-carousel-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* A card's accordion heading — "Card N" plus a truncated description preview. min-width:0 lets
   the noWrap caption actually ellipsize inside the accordion's own header row. */
.br-tpl-form-carousel-card-heading {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

/* A card's accordion content — media picker, description, and button rows, same gap rhythm as
   .br-tpl-form-card's own top-level contents. */
.br-tpl-form-carousel-card-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.br-tpl-form-carousel-card-toolbar {
  display: flex;
  justify-content: flex-end;
}

/* A card description's own action row: Add-variable + emoji buttons, count pushed right — same
   layout and MUI min-width override as .br-tpl-form-body-toolbar above, duplicated under its own
   name since it's scoped to a carousel card rather than the Body field. */
.br-tpl-form-carousel-description-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
}
.br-tpl-form-carousel-description-actions .br-tpl-form-char-count {
  margin-left: auto;
  align-self: center;
}
.br-tpl-form-carousel-description-actions .MuiButton-root {
  flex: none;
  white-space: nowrap;
}
.br-tpl-form-carousel-description-actions .MuiButton-text {
  min-width: 0;
  padding: 4px 8px;
}

/* A card's own inline media preview (img/video), shown once a file is picked. Same capped-height
   + object-fit pattern as .br-tpl-form-media-preview (Header.js's single media field), sized
   smaller since a carousel card is one of several stacked inside the accordion list. */
.br-tpl-form-carousel-media-preview {
  display: block;
  width: 100%;
  max-height: 140px;
  object-fit: contain;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-radius);
}

/* One card's button entry — parallel to .br-tpl-form-buttons-row but scoped to a carousel
   card. */
.br-tpl-form-carousel-button-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid var(--br-card-border);
  border-radius: var(--br-card-radius);
}

/* Toggled on a card's drop-target wrapper while a dragged card is hovered over it (drag-to-
   reorder). Outline rather than border so the highlight can't nudge the card's own layout/height. */
.br-tpl-form-carousel-card--drag-over {
  outline: 2px dashed var(--br-accent);
  outline-offset: 2px;
  border-radius: var(--br-card-radius);
}

/* Content wrapper inside the pre-submit preview Modal — the submit error (if any) stacked above
   the console-mirrored two-column row below (Form/index.js). */
.br-tpl-form-preview-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Console's own PreviewSubmit.tsx layout: details card left, phone preview right. */
.br-tpl-form-preview-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
}

.br-tpl-form-preview-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 320px;
  min-width: 280px;
  max-width: 520px;
}

.br-tpl-form-preview-subtitle {
  color: var(--br-muted);
}

/* Mirrors the console's own .previewModal (CreateTemplate/styles.module.css): white card, 15px
   gap between lines, a grey ring instead of a soft shadow. box-shadow reuses --br-card-border
   (this file's existing hairline grey) rather than inventing a new colour — console uses its own
   theme's grey-600 for the same ring. word-break is our own addition, not the console's: a long
   template name can otherwise overflow the ~320-520px column. */
.br-tpl-form-preview-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  background: var(--palette-common-white, #fff);
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 1px 3px 1px var(--br-card-border);
  margin: 5px;
  font-size: 14px;
  word-break: break-word;
}

.br-tpl-form-preview-card p {
  margin: 0;
}

.br-tpl-form-preview-title {
  color: var(--br-accent);
  font-size: 16px;
}

/* Header/Template/Example lines each join a label and its value with a literal \\n — preserve it
   (and any line break already in the body text itself) instead of collapsing it. */
.br-tpl-form-preview-multiline {
  white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./src/styles/templates.css"],"names":[],"mappings":"AAAA,gGAAgG;;AAEhG;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA,+FAA+F;AAC/F;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;;;;;6CAK6C;AAC7C;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;iEAGiE;AACjE;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;0EAC0E;AAC1E;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB;;;eAGa;EACb,cAAc;AAChB;;AAEA;;uCAEuC;AACvC;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,oDAAoD;EAEpD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;;uEAGuE;AACvE;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;4DAC4D;AAC5D;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,uCAAuC;EACvC,oCAAoC;EACpC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;2BAC2B;AAC3B;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;;;gCAGgC;AAChC;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,yEAAyE;EACzE,0BAA0B;EAC1B,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;;;;gFAMgF;AAChF;EACE,WAAW;AACb;;AAEA;+BAC+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;mEACmE;AACnE;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;mEACmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uCAAuC;EACvC,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;wDAEwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;sEACsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;gEAEgE;AAChE;EACE,SAAO;EACP,YAAY;AACd;;AAEA,uFAAuF;AACvF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA,0IAA0I;AAC1I;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,mGAAmG;AACnG;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;8BAI8B;AAC9B;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;;;;oFAOoF;AACpF;EACE,eAAe;EACf,aAAa;AACf;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;yDACyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,qDAAqD;AACrD;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;oFACoF;AACpF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;;0DAE0D;AAC1D;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;qFACqF;AACrF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,6FAA6F;AAC7F;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;wEAEwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;qDACqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;iFACiF;AACjF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;gDACgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;uFAEuF;AACvF;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;UACU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;oGACoG;AACpG;EACE,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;+DAC+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;gEAIgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;mFACmF;AACnF;EACE,qBAAqB;AACvB","sourcesContent":["/* Templates tab — list screen (card grid). Class names prefixed br-tpl- per house convention. */\n\n.br-tpl {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 24px 0;\n}\n\n/* Page header: title + description on the left, channel select + create action on the right. */\n.br-tpl-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.br-tpl-header-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.br-tpl-header-title {\n  margin: 0;\n  color: var(--br-text);\n  font-weight: 600;\n}\n\n.br-tpl-header-subtitle {\n  margin: 0;\n  color: var(--br-muted);\n}\n\n.br-tpl-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n/* Icon-only Refresh button (List.js). The library sets its size styles (minWidth, padding) under\n   sx's \"&.MuiButton-root\" — two classes, (0,2,0) specificity — so this override needs two classes\n   too; it wins at equal specificity because ThemeProvider injects MUI's styles first (injectFirst).\n   Same pattern as .br-tpl-form-body-toolbar .MuiButton-text elsewhere in this file.\n   customStartIcon renders as a plain <img>, not through MUI's startIcon slot, so there's no\n   .MuiButton-startIcon margin to zero out. */\n.br-tpl-header-actions .br-tpl-refresh-button {\n  min-width: 36px;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* Channel select, its own row between the header and the rail/grid layout. Flex-wrapped\n   (not block) so the Select sizes to its own small footprint instead of stretching full\n   width; vertical spacing above/below comes from .br-tpl's own flex `gap`, same as every\n   other direct child of .br-tpl — no extra margin needed here. */\n.br-tpl-channel-row {\n  display: flex;\n  align-items: center;\n}\n\n/* Two-column body below the header: a plain status rail on the left, search + grid +\n   pagination on the right — this pairing runs for the rest of the page. */\n.br-tpl-layout {\n  display: flex;\n  align-items: flex-start;\n  gap: 32px;\n}\n\n.br-tpl-rail {\n  flex: 0 0 180px;\n  display: flex;\n  flex-direction: column;\n  /* No offset: .br-tpl-rail and .br-tpl-main are flex-start siblings in .br-tpl-layout, and the\n     search TextField below carries no label of its own, so its outlined box already sits flush\n     with the layout's top edge — the Status heading needs the same flush start to line up\n     with it. */\n  padding-top: 0;\n}\n\n/* Section label above the status buttons — quiet, doesn't compete with the items. Left padding\n   matches an item's own text start (2px border-left + 12px padding-left = 14px) so \"Status\"\n   and \"All\" share one vertical edge. */\n.br-tpl-rail-heading {\n  margin: 0 0 6px;\n  padding-left: 14px;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: var(--br-faint);\n}\n\n.br-tpl-rail-item {\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  border-left: 2px solid transparent;\n  padding: 7px 12px;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--br-muted);\n  cursor: pointer;\n  border-radius: 0 var(--br-radius) var(--br-radius) 0;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.br-tpl-rail-item:hover {\n  color: var(--br-text);\n  background: var(--br-hover);\n}\n\n/* Native buttons keep a UA focus ring even after the reset above, and a click focuses the\n   button too — so the just-clicked rail item (the one now shown active) picked up an extra\n   ring the others never show, reading as misaligned. Drop the plain :focus ring and draw an\n   explicit :focus-visible one instead, inset so it never adds width. */\n.br-tpl-rail-item:focus {\n  outline: none;\n}\n\n.br-tpl-rail-item:focus-visible {\n  outline: 2px solid var(--br-accent);\n  outline-offset: -2px;\n}\n\n.br-tpl-rail-item--active {\n  color: var(--br-accent);\n  font-weight: 600;\n  border-left-color: var(--br-accent);\n  background: var(--br-hover-strong);\n}\n\n.br-tpl-main {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.br-tpl-search-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.br-tpl-search-input {\n  width: 360px;\n  max-width: 100%;\n}\n\n.br-tpl-empty {\n  margin: 0;\n  padding: 40px 0;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 300;\n  color: var(--br-muted);\n}\n\n/* Card grid — 3 per row, wrapping to fewer on narrower widths. Shared by the real grid and\n   the loading skeleton below so both lay out identically. */\n.br-tpl-card-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n}\n\n@media (max-width: 1100px) {\n  .br-tpl-card-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 700px) {\n  .br-tpl-card-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.br-tpl-card {\n  display: flex;\n  flex-direction: column;\n  min-height: 420px;\n  min-width: 0;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-card-radius);\n  background: var(--palette-common-white, #fff);\n  overflow: hidden;\n}\n\n.br-tpl-card-header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px 12px 0;\n}\n\n.br-tpl-card-title {\n  color: var(--br-text);\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.br-tpl-card-preview {\n  flex: 1 1 auto;\n  min-height: 280px;\n  padding: 6px 12px;\n  overflow: hidden;\n}\n\n/* Slightly tinted vs. the card's white body — echoes the console's own darker \"Last Updated\"\n   bar under its preview. */\n.br-tpl-card-footer {\n  padding: 6px 12px;\n  background: var(--br-head-bg);\n  border-top: 1px solid var(--br-rule);\n}\n\n.br-tpl-card-updated {\n  margin: 0;\n  font-size: 11px;\n  font-style: italic;\n  color: var(--br-muted);\n}\n\n.br-tpl-card-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 12px;\n  border-top: 1px solid var(--br-rule);\n}\n\n/* Loading state — the design system has no Skeleton component, so this mirrors the shimmer\n   look overrides.css already uses for br-skeleton__row, reshaped into card-shaped\n   placeholders (List.js renders PAGE_SIZE of these inside .br-tpl-card-grid above) instead\n   of the old row-shaped ones. */\n.br-tpl-card-skeleton {\n  padding: 12px;\n  gap: 10px;\n}\n\n.br-tpl-skeleton-bar,\n.br-tpl-skeleton-block {\n  background: linear-gradient(90deg, #f5f5f8 25%, #eceef2 37%, #f5f5f8 63%);\n  background-size: 400% 100%;\n  animation: br-tpl-skeleton-pulse 1.4s ease infinite;\n}\n\n.br-tpl-skeleton-bar {\n  border-radius: 4px;\n}\n\n.br-tpl-skeleton-block {\n  flex: 1 1 auto;\n  min-height: 200px;\n  border-radius: 8px;\n}\n\n@keyframes br-tpl-skeleton-pulse {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n\n/* Pagination's own component renders its page-pills and \"Results: X-Y of Z\" text as two\n   children of a wrapper it styles `justify-content: space-between` — but that same wrapper\n   is `margin: 1rem auto` with no explicit width, so as a direct flex item of .br-tpl-main's\n   column layout it never stretches (auto cross-axis margins opt a flex item out of\n   align-items: stretch), shrinks to fit-content, and the space-between gap collapses to\n   zero. This plain block wrapper takes it out of the flex-item position so Pagination lays\n   out in normal block flow instead, where auto width does fill the container. */\n.br-tpl-pagination-row {\n  width: 100%;\n}\n\n/* Read-only detail modal (DetailModal.js). Two columns: facts + message parts on the left, the\n   live preview on the right. */\n.br-tpl-detail {\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n}\n\n.br-tpl-detail-facts {\n  flex: 1 1 340px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Fixed-ish width so the WhatsApp-shaped preview keeps its own aspect ratio — never squeezed\n   below ~300px even as the facts column beside it gets narrower. */\n.br-tpl-detail-preview {\n  flex: 0 0 320px;\n  min-width: 300px;\n}\n\n.br-tpl-detail-list {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  row-gap: 10px;\n  column-gap: 12px;\n  margin: 0;\n}\n\n.br-tpl-detail-list dt {\n  margin: 0;\n  color: var(--br-muted);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.br-tpl-detail-list dd {\n  margin: 0;\n  color: var(--br-text);\n  font-size: 13px;\n  word-break: break-word;\n}\n\n.br-tpl-detail-list--parts {\n  padding-top: 16px;\n  border-top: 1px solid var(--br-rule);\n}\n\n.br-tpl-detail-list--parts dd {\n  white-space: pre-wrap;\n}\n\n/* Create/edit form shell (Form/index.js). */\n.br-tpl-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding: 24px 0;\n}\n\n.br-tpl-form-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.br-tpl-form-panes {\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n}\n\n.br-tpl-form-pane-form {\n  flex: 1 1 67%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.br-tpl-form-pane-preview {\n  flex: 0 1 33%;\n  min-width: 300px;\n  position: sticky;\n  top: 24px;\n}\n\n.br-tpl-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* One card per section (Form/sections/*.js). The 25px gap between cards comes from\n   .br-tpl-form-pane-form's own gap above, not a per-card margin. */\n.br-tpl-form-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-card-radius);\n}\n\n.br-tpl-form-card-heading-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.br-tpl-form-card-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.br-tpl-form-optional-pill {\n  font-size: 11px;\n  font-weight: 500;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--br-rule);\n  color: var(--br-muted);\n}\n\n.br-tpl-form-helper-text {\n  margin: 0;\n  color: var(--br-muted);\n}\n\n.br-tpl-form-char-count {\n  align-self: flex-end;\n  color: var(--br-muted);\n}\n\n/* Category section's radio card grid (sections/Category.js). Three equal-width cards; grid's\n   own align-items: stretch default plus height: 100% on the card makes every card as tall as\n   the tallest description instead of shrink-to-fit around its own text. */\n.br-tpl-form-category-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.br-tpl-form-category-card {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  height: 100%;\n  margin: 0;\n  padding: 12px;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-card-radius);\n  cursor: pointer;\n}\n\n.br-tpl-form-category-card--selected {\n  border-color: var(--br-accent);\n}\n\n/* Radio, title, then the icon pushed to the card's right edge. Category.js renders the category\n   icon through Icon's customPath (a hosted SVG), which gupshup-ts-components renders as a plain\n   <img> — img:last-child is the real target, not svg. */\n.br-tpl-form-category-card-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.br-tpl-form-category-card-head img:last-child {\n  margin-left: auto;\n}\n\n.br-tpl-form-category-radio-input {\n  flex: none;\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--br-accent);\n  cursor: pointer;\n}\n\n.br-tpl-form-subcategory {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* Template Type dropdown item (sections/Category.js's SubcategoryOptionLabel) — title row (+ an\n   info tooltip icon for Carousel), then the description underneath. */\n.br-tpl-form-subcategory-option {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n/* Message validity Select sits beside the Authentication-only info tooltip (sections/\n   MessageValidity.js), inside a .br-tpl-form-inline-row. flex:1 lets it fill the row; min-width:0\n   stops its own width:100% from pushing the tooltip icon out. */\n.br-tpl-form-validity-select {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Body toolbar sits under the text area: actions left, character count pushed right. */\n.br-tpl-form-body-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 8px;\n}\n/* The shared rule's align-self: flex-end suits the column-flex card, but bottom-aligns this text in the row-flex toolbar — recenter it. */\n.br-tpl-form-body-toolbar .br-tpl-form-char-count {\n  margin-left: auto;\n  align-self: center;\n}\n\n/* MUI Button reserves min-width:64px, which scatters these single-glyph controls across the row. */\n.br-tpl-form-body-toolbar .MuiButton-root {\n  flex: none;\n  white-space: nowrap;\n}\n.br-tpl-form-body-toolbar .MuiButton-text {\n  min-width: 0;\n  padding: 4px 8px;\n}\n\n/* Wraps just the emoji toggle button; inline-flex keeps it sized to the button, not stretched by\n   the row. EmojiPickerButton.js measures this element's getBoundingClientRect() to position the\n   portaled popover below — the popover is no longer a CSS-anchored child of this wrapper, so\n   `position: relative` here is vestigial (harmless, kept so this wrapper's own box is unaffected)\n   rather than load-bearing. */\n.br-tpl-form-emoji-picker-anchor {\n  position: relative;\n  display: inline-flex;\n}\n\n/* Rendered through a React portal onto document.body (EmojiPickerButton.js), not as a DOM child\n   of .br-tpl-form-emoji-picker-anchor above — so no ancestor's overflow (a carousel card, the\n   sticky preview pane, index.css's tabsPanel) can clip it regardless of scroll position, which is\n   what broke on a low-on-the-page trigger with the page already at max scroll. top/left are set\n   inline per-open from the trigger's own rect (EmojiPickerButton.js's computePopoverPosition), so\n   only `position` and `z-index` are fixed here. z-index clears every z-index already in this app:\n   this stylesheet's own card/sticky-header values (1-5, index.css 3-4) and gupshup-ts-components'\n   Modal, which is MUI's Modal under the hood and defaults to zIndex.modal = 1300. */\n.br-tpl-form-emoji-picker-popover {\n  position: fixed;\n  z-index: 1400;\n}\n\n/* Variables section rows (sections/Variables.js). */\n.br-tpl-form-variable-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* One sample-value row — wraps the row's TextField; the token adornment itself renders inside\n   the input via startAdornment, not as a sibling here. */\n.br-tpl-form-variable-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.br-tpl-form-variable-token {\n  color: var(--br-muted);\n  margin-right: 4px;\n}\n\n/* Header/media inline states (sections/Header.js). */\n.br-tpl-form-header-text,\n.br-tpl-form-header-media {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* Header text's own action row: Add-variable button left, character count pushed right — same\n   idea as .br-tpl-form-body-toolbar below, scoped to the header text field alone. */\n.br-tpl-form-header-text-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.br-tpl-form-media-picked {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-radius);\n}\n\n/* Inline preview of a picked sample media file (img/video/iframe), shown above\n   .br-tpl-form-media-picked once a file is selected. Capped height with object-fit so a large\n   image, video or PDF can't blow out the form's layout. */\n.br-tpl-form-media-preview {\n  display: block;\n  width: 100%;\n  max-height: 180px;\n  object-fit: contain;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-radius);\n}\n\n/* Buttons section (sections/Buttons.js). */\n.br-tpl-form-buttons-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* One button entry — title/remove strip stacked above its type-specific fields; nested one\n   level inside .br-tpl-form-card, hence the smaller padding than a top-level card. */\n.br-tpl-form-buttons-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-card-radius);\n}\n\n.br-tpl-form-buttons-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Drop-target affordance while dragging a button row over another one via its drag handle. */\n.br-tpl-form-buttons-row--drag-over {\n  border-color: var(--br-accent);\n  background: var(--br-hover);\n}\n\n/* Shared by the dynamic-suffix row (the {{1}} token sits inline to the left of the sample-suffix\n   input, so the variable WhatsApp appends is visible rather than only described) and the\n   deep-link/fallback-URL rows (field plus its trailing info tooltip). */\n.br-tpl-form-url-suffix-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.br-tpl-form-url-suffix-token {\n  flex: none;\n  font-size: 12px;\n  color: var(--br-muted);\n  white-space: nowrap;\n}\n\n/* Checkbox plus its info icon on one line. */\n.br-tpl-form-inline-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* App setup rows (sections/AuthAppSetup.js) — package name + signature hash inputs share the\n   row, the remove icon keeps its own natural size. */\n.br-tpl-form-app-setup-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.br-tpl-form-app-setup-row > *:not(:last-child) {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n/* Carousel section (sections/Carousel.js). */\n.br-tpl-form-carousel-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* A card's accordion heading — \"Card N\" plus a truncated description preview. min-width:0 lets\n   the noWrap caption actually ellipsize inside the accordion's own header row. */\n.br-tpl-form-carousel-card-heading {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n/* A card's accordion content — media picker, description, and button rows, same gap rhythm as\n   .br-tpl-form-card's own top-level contents. */\n.br-tpl-form-carousel-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.br-tpl-form-carousel-card-toolbar {\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* A card description's own action row: Add-variable + emoji buttons, count pushed right — same\n   layout and MUI min-width override as .br-tpl-form-body-toolbar above, duplicated under its own\n   name since it's scoped to a carousel card rather than the Body field. */\n.br-tpl-form-carousel-description-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 8px;\n}\n.br-tpl-form-carousel-description-actions .br-tpl-form-char-count {\n  margin-left: auto;\n  align-self: center;\n}\n.br-tpl-form-carousel-description-actions .MuiButton-root {\n  flex: none;\n  white-space: nowrap;\n}\n.br-tpl-form-carousel-description-actions .MuiButton-text {\n  min-width: 0;\n  padding: 4px 8px;\n}\n\n/* A card's own inline media preview (img/video), shown once a file is picked. Same capped-height\n   + object-fit pattern as .br-tpl-form-media-preview (Header.js's single media field), sized\n   smaller since a carousel card is one of several stacked inside the accordion list. */\n.br-tpl-form-carousel-media-preview {\n  display: block;\n  width: 100%;\n  max-height: 140px;\n  object-fit: contain;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-radius);\n}\n\n/* One card's button entry — parallel to .br-tpl-form-buttons-row but scoped to a carousel\n   card. */\n.br-tpl-form-carousel-button-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  border: 1px solid var(--br-card-border);\n  border-radius: var(--br-card-radius);\n}\n\n/* Toggled on a card's drop-target wrapper while a dragged card is hovered over it (drag-to-\n   reorder). Outline rather than border so the highlight can't nudge the card's own layout/height. */\n.br-tpl-form-carousel-card--drag-over {\n  outline: 2px dashed var(--br-accent);\n  outline-offset: 2px;\n  border-radius: var(--br-card-radius);\n}\n\n/* Content wrapper inside the pre-submit preview Modal — the submit error (if any) stacked above\n   the console-mirrored two-column row below (Form/index.js). */\n.br-tpl-form-preview-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Console's own PreviewSubmit.tsx layout: details card left, phone preview right. */\n.br-tpl-form-preview-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 15px;\n}\n\n.br-tpl-form-preview-col {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1 1 320px;\n  min-width: 280px;\n  max-width: 520px;\n}\n\n.br-tpl-form-preview-subtitle {\n  color: var(--br-muted);\n}\n\n/* Mirrors the console's own .previewModal (CreateTemplate/styles.module.css): white card, 15px\n   gap between lines, a grey ring instead of a soft shadow. box-shadow reuses --br-card-border\n   (this file's existing hairline grey) rather than inventing a new colour — console uses its own\n   theme's grey-600 for the same ring. word-break is our own addition, not the console's: a long\n   template name can otherwise overflow the ~320-520px column. */\n.br-tpl-form-preview-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 15px;\n  background: var(--palette-common-white, #fff);\n  padding: 15px;\n  border-radius: 10px;\n  box-shadow: 0 1px 3px 1px var(--br-card-border);\n  margin: 5px;\n  font-size: 14px;\n  word-break: break-word;\n}\n\n.br-tpl-form-preview-card p {\n  margin: 0;\n}\n\n.br-tpl-form-preview-title {\n  color: var(--br-accent);\n  font-size: 16px;\n}\n\n/* Header/Template/Example lines each join a label and its value with a literal \\n — preserve it\n   (and any line break already in the body text itself) instead of collapsing it. */\n.br-tpl-form-preview-multiline {\n  white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
